import { useSelector } from "react-redux";
import { getMarketingTrackingVariable } from "@flights/web-api-utils-universal";
import useGlobalContext from "./useGlobalContext.js";
import { getFlightPointOfSale } from "../store/flightDetails/selectors.js";
import { getOrderCountry } from "../store/order/selectors.js";
import { getSearchPointOfSale } from "../store/searchResults/selectors.js";
export default function usePointOfSale() {
    const flightPointOfSale = useSelector(getFlightPointOfSale);
    const orderCountry = useSelector(getOrderCountry);
    const searchPointOfSale = useSelector(getSearchPointOfSale);
    const { ipCountry, pointOfSaleFromSelectedCurrency } = useGlobalContext();
    const resolvedPointOfSale = orderCountry ||
        flightPointOfSale ||
        searchPointOfSale ||
        getMarketingTrackingVariable("salesCountry") ||
        pointOfSaleFromSelectedCurrency ||
        ipCountry ||
        undefined;
    return resolvedPointOfSale && resolvedPointOfSale.toLowerCase();
}
